import {
  FilterWithValues,
  filterWithValuesFromResponse,
  filterWithValuesToUpsertRequest,
} from '../interfaces/ProductFilter/FilterWithValues';
import api, { adminApiPrefix } from './Api';
import {
  FilterValue,
  filterValueFromResponse,
  filterValueToUpsertRequest,
} from '../interfaces/ProductFilter/FilterValue';
import {
  FilterKey,
  filterKeyFromResponse,
} from '../interfaces/ProductFilter/FilterKey';
import {
  FilterKVP,
  filterKVPFromResponse,
} from '../interfaces/ProductFilter/FilterKVP';

const productFilterAdminApiPrefix = `${adminApiPrefix}/filters`;

export const createFilterKey = async (
  filterKey: FilterWithValues,
): Promise<FilterWithValues> => {
  const response = await api.post(
    productFilterAdminApiPrefix,
    filterWithValuesToUpsertRequest(filterKey),
  );

  return filterWithValuesFromResponse(response.data?.data);
};

export const createFilterValue = async (
  keyID: number,
  filterValue: FilterValue,
): Promise<FilterValue> => {
  const response = await api.post(
    `${productFilterAdminApiPrefix}/value/${keyID}`,
    filterValueToUpsertRequest(filterValue),
  );

  return filterValueFromResponse(response.data?.data);
};

export const getFilterKeys = async (): Promise<FilterKey[]> => {
  const response = await api.get(productFilterAdminApiPrefix);

  return (response.data?.data ?? []).map((filterKey: any) =>
    filterKeyFromResponse(filterKey),
  );
};

export const getFilterWithValues = async (
  id: number,
): Promise<FilterWithValues> => {
  const response = await api.get(`${productFilterAdminApiPrefix}/${id}`);

  return filterWithValuesFromResponse(response.data?.data);
};

export const getFilterKVPs = async (): Promise<FilterKVP[]> => {
  const response = await api.get(`${productFilterAdminApiPrefix}/kvps`);

  return (response.data?.data ?? []).map((kvp: any) =>
    filterKVPFromResponse(kvp),
  );
};

export const updateFilterKey = async (
  filterKey: FilterWithValues,
): Promise<FilterWithValues> => {
  const response = await api.put(
    `${productFilterAdminApiPrefix}/${filterKey.id}`,
    filterWithValuesToUpsertRequest(filterKey),
  );

  return filterWithValuesFromResponse(response.data?.data);
};

export const updateFilterValue = async (
  filterValue: FilterValue,
): Promise<FilterValue> => {
  const response = await api.put(
    `${productFilterAdminApiPrefix}/value/${filterValue.id}`,
    filterValueToUpsertRequest(filterValue),
  );

  return filterValueFromResponse(response.data?.data);
};

export const deleteFilterKey = async (id: number): Promise<void> =>
  api.delete(`${productFilterAdminApiPrefix}/${id}`);

export const deleteFilterValue = async (id: number): Promise<void> =>
  api.delete(`${productFilterAdminApiPrefix}/value/${id}`);
